
import { clearRoom, conferenceLeft, getGroupId, getRoomOption, setGroupId } from './features/base/conference';
import { checkInGroupByUserId, participantRoleChanged, ROLE } from './features/base/participants';
import { getGroupName, setGroupPanel, setGroupUpdate } from './features/group';
import { GROUP_DEFAULT_NAME } from './features/group/constants';
import { clearNotifications } from './features/notifications';
import { setScreenVideoShareState } from './features/screen-share';
import { createTaskQueue } from './modules/util/helpers';
import TempMate from "./server/mate/TempMate";
import jitsi from './server/jitsi';
import { default as Mate } from './server/mate/index';

const task = createTaskQueue();
let goToGroup;
class MateManagement {
    constructor() {
        this.mateServer = new Mate();
        this.mediaServer = jitsi;
        this.tempServer = new TempMate();
        this.accessToken = null;
        this.meeting_uuid = null;
        this.group_id = null;

        this.groupWebsocket = new Map();

        this.currentGroupId = null;

        this.connectionGroupId = null;
    }

    init() {
        this.mateServer.init();
        this.mediaServer.init();
    }

    getTempMate() {
        return this.tempServer;
    }

    unload() {
        if (this.getScreenSharing())  this.toggleScreenShare(false);
        APP.store.dispatch(conferenceLeft());
        
        window.close();

        this.disconnect();

        this.groupWebsocket.forEach(g => {
            if (g.websocket) g.events.leave();
        });

        this.groupWebsocket = new Map();
    }

    // room option 
    getRoom(type) {
        const room = getRoomOption(APP.store.getState());
        
        if (type === 'uuid') return room.uuid;
        if (type === 'code') return room.code;
        return room.name;
    }

    getGroupWebsocket(groupId) {
        if (groupId === "") return false;
        let group = this.groupWebsocket.get(groupId);

        if (!group) {
            const newGroup = new Mate(groupId);
            group = newGroup;

            this.groupWebsocket.set(groupId, group);
        }

        return group;
    }

    handlerGroupJoin(groupId, change) {
        const currentGroupId = getGroupId(APP.store.getState());
        
        if (groupId === "") {
            this.mateServer.events.join(true);
        
            APP.store.dispatch(setGroupId(groupId));
            APP.store.dispatch(setGroupUpdate(new Date()));  
            APP.UI.showLoading(false);
        } else {
            APP.store.dispatch(setGroupPanel(false));
                        
            goToGroup = setTimeout(() => {
                const group = this.getGroupWebsocket(groupId);
                group.init();
                group.connection.connect();

                APP.store.dispatch(setGroupId(groupId));

                APP.store.dispatch(setGroupUpdate(new Date()));      
                APP.UI.showLoading(false); 
            }, 2000);
        }       
    }

    startGroupMeeting(groupId, change) { 
        const name = getGroupName(APP.store.getState(), groupId) || GROUP_DEFAULT_NAME;
        APP.UI.showLoading(true, `${name}`);

        if (change) {
            clearTimeout(goToGroup);
            APP.store.dispatch(clearNotifications());     
            APP.store.dispatch(clearRoom());    
        }
        this.handlerGroupJoin(groupId, change);
    }

    changeMeetingRoom(groupId) {
        clearTimeout(goToGroup);

        // 현재 할당된 그룹 
        const currentGroupId = getGroupId(APP.store.getState());
        if (currentGroupId !== groupId) {
            // 초기화 
            APP.store.dispatch(clearNotifications());     
            APP.store.dispatch(clearRoom());    
            if (this.getScreenSharing()) {
                this.toggleScreenShare(false);
            }
        } 
        // 입장 중인 그룹 left 
        this.endMeetingRoom(currentGroupId);  
        // 새로운 그룹 시작
        this.startGroupMeeting(groupId, false);              
    }

    endMeetingRoom(groupId) {
        // 종료된 그룹 
        if (groupId !== "") {
            const group = this.getGroupWebsocket(groupId);
            // 그룹 나가기
            if (group) group.events.leave();  
        }      
    }

    /**
     * CONNECTION
     */
    // 연결
    connection() {
        // 메이트 서버 연결 
        this.mateServer.connection.connect();   
    }

    mediaServerConnection() {
        // 짓시 연결
        this.mediaServer.connect();
    }

    disconnect() {
        this.mateServer.leave();
        this.mediaServer.disconnect();
    }

    // device 
    // 장치 초기 설정
    loadDevice() {
        return this.mateServer.track.loadDevice();
    }
    listenForAudioUpdates(stream) {
        this.mateServer.track.listenForAudioUpdates(stream);
    }
    addDeviceListChange(remoteDeviceChagne) {
        this.mateServer.track.addDeviceListChange(remoteDeviceChagne);
    }
    removeDeviceListChange() {
        this.mateServer.track.removeDeviceListChange();
    }

    // 회의실 
    getMyUserId() {
        return this.mediaServer.getMyUserId();
    }
    getSpeakerStats() {
        return this.mediaServer.getSpeakerStats();
    }

    getAccessToken() {
        return this.accessToken;
    }
    setAccessToken(accessToken) {
        this.accessToken = accessToken;
    }
    getMeetingId() {
        return this.meeting_uuid;
    }
    setMeetingId(meeting_uuid) {
        this.meeting_uuid = meeting_uuid;
    }
    setCurGroupId(group_id) {
        this.currentGroupId = group_id;
    }
    getCurGroupId() {
        return this.currentGroupId;
    }

    getMediaServerId() {
        return this.mediaServer.getMyUserId();
    }
    

    /**
     * DEVICE 장치 설정
     */    
    getVdoErrorMsg(err) {
        return this.mateServer.track.getVdoErrorMsg(err);
    }   
    getMicErrorMsg(err) {
        return this.mateServer.track.getMicErrorMsg(err);
    }   

    getLocalTracksInitialized() {
        return this.mediaServer.getLocalTracksInitialized();
    }
    // conference 입장 전 device list
    initDevice() {
        return this.mediaServer.initDevice(true);
    }
    
    // LOCAL TRACK
    createLocalTracks(options) {
        return this.mediaServer.createLocalTracks(options);
    }
    // 실패시 LOCAL TRACK 재시도
    createLocalTrackA(options) {
        return this.mediaServer.createLocalTrackA(options);
    }
    // TRACK 추가
    trackAdded(track) {
        this.mediaServer.trackAdded(track);
    }
    // TRACK 파괴?
    disposeTracks(tracks) {
        return this.mediaServer.disposeTracks(tracks);
    }
    // TRACK 음소거
    setTrackMuted(track, muted) {
        return this.mediaServer.setTrackMuted(track, muted);
    }

    /**
     * Mute
     */
    toggleVideoMuted(showUI) {
        try {
            this.mediaServer.toggleVideoMuted((showUI = true));
        } catch (e) {
            console.log(e);
        }
    }
    toggleAudioMuted(showUI) {
        try {
            this.mediaServer.toggleAudioMuted((showUI = true));
        } catch (e) {
            console.log(e);
        }
    }

    /**
     * CONFERENCE TRACK
     */
    deviceUnload() {
        return this.mediaServer.deviceUnload();
    }
    addConferenceTrack(track) {
        return this.mediaServer.addLocalTracksToConference(
            track,
        );
    }
    replaceConferenceTrack(oldTrack, newTrack) {
        return this.mediaServer.replaceConferenceTrack( oldTrack, newTrack);
    }
    removeConferenceTrack(track) {
        return this.serverList[
            this.mediaServer
        ].removeLocalTracksFromConference(track);
    }
    toggleScreenShare(toggle) {
        return this.mediaServer.toggleScreenShare(toggle);
    }
    screenConnect() {
        return this.mediaServer.screenConnect();
    }
    getScreenSharing() {
        return this.mediaServer.getScreenSharing();
    }
    
    listenForAudioLevelUpdates(track) {
        return this.mediaServer.listenForAudioLevelUpdates(
            track,
        );
    }
    removeForAudioLevelUpdates(track) {
        return this.mediaServer.removeForAudioLevelUpdates(
            track,
        );
    }
    getAudioOutputDeviceId() {
        try {
            return this.mediaServer.getAudioOutputDeviceId();
        } catch (e) {
            console.log(e);
        }
    }
    setAudioOutputDevice(newId) {
        try {
            return this.mediaServer.setAudioOutputDevice(
                newId,
            );
        } catch (e) {
            return true;
        }
    }

    // send end point (use websocket)
    sendActionMessage(data) {
        try {
            this.mediaServer.sendActionMessage(data);
        } catch (e) {
            console.log(e);
            // this.serverList[this.actionServer].sendActionMessage(data);
        }
    }

    /**
     * START YOUTUBE STREAMING
     */
    toggleYoutubeStream(toggle, streamKey) {
        return this.mediaServer.toggleYoutubeStreaming(
            toggle,
            streamKey,
        );
    }

    /**
     * MATE2 ACTION
     */
    
    getEventServer() {
        let server = this.mateServer;

        const currentGroupId = getGroupId(APP.store.getState());
        if (currentGroupId && currentGroupId !== "") {
            const websocket = this.getGroupWebsocket(currentGroupId);
            if (websocket) server = websocket;
        }

        return server;
    }
    
    // set 영상 session id 
    setJitsiId(jitsi_id) {
        this.mateServer.events.setJitsiId(jitsi_id);
    }
    // 현재 레이아웃 모드 변경
    setLayoutMode(mode, viewVisible) {
        const server = this.getEventServer();
        server.events.setLayoutMode(mode, viewVisible);       
    }
    // 그리드 모드 default count 
    requestSetGridCount(grid_count) {
        const server = this.getEventServer();
        server.events.setGridCount(grid_count);
    }
    // pin 알림
    setPinned(member_uuid) {
        const server = this.getEventServer();
        server.events.setPinned(true, member_uuid);
    }
    // pin 제거 알림
    removePinned(member_uuid) {
        const server = this.getEventServer();
        server.events.setPinned(false, member_uuid);
    }
    // recording 알림
    setRecording(recording, member_uuid) {
        const server = this.getEventServer();
        server.events.setRecording(recording, member_uuid);
    }
    // 사용자 역할 변경
    async setParticipantRole(role, user_uuid) {
        // const currentGropuId = getGroupId(APP.store.getState());
        // if (currentGropuId === "") {
        //     if (role === ROLE.HOST || role === ROLE.MANAGER) {
        //         // 그룹에 속해 있는 지 확인 
        //         const inGroup = checkInGroupByUserId(APP.store.getState(), user_uuid);
        //         if (inGroup) {
        //             const { complete, message } = await APP.API.assignGroup({ members: [{ user_id: inGroup.user_id, role_name: ROLE.ADMIN }], method: "reset" }, inGroup.group_id);
        //             if (complete) {
                        
        //             } else {
        //                 alert(message);
        //                 return;
        //             }
        //         }     
        //     } 
        // }
        
        APP.store.dispatch(participantRoleChanged(user_uuid, role));
        const server = this.getEventServer();
        server.events.setParticipantRole(role, user_uuid);
    }
    // 화면 공유 종료 요청
    requestStopScreenShare() {
        const server = this.getEventServer();
        server.events.setScreenOption({ user_id: null, jitsi_id: null });

        APP.store.dispatch(setScreenVideoShareState(false));
    }

    // 문서 
    // 문서 저장 
    sendShareDocument(data) {
        const server = this.getEventServer();
        server.events.sendShareDocument(data);
    }
    // 문서 삭제 
    deleteShareDocument(uuid) {
        const server = this.getEventServer();
        server.events.deleteShareDocument(uuid);
    }
    // 문서 공유 focus item 
    requestFocusItem(focusItem) {
        const server = this.getEventServer();
        server.events.setFocusItem(focusItem);
    }
    // 문서 캔버스 
    sendPointer(key, value, isWhiteBoard, uuid, index) {
        const server = this.getEventServer();
        server.events.sendPointer(key, value, isWhiteBoard, uuid, index);
    }
    // 문서 캔버스 삭제
    deletePointer(key, isAll, isWhiteBoard, focusUuid, focusIndex) {
        const server = this.getEventServer();
        server.events.deletePointer(key, isAll, isWhiteBoard, focusUuid, focusIndex);
    }

    // 손들기 (발표자 요청)
    raiseHand() {
        const server = this.getEventServer();
        server.events.requestPresentation();
    }
    // 발표자 응답
    responsePresentation(member_uuid, accepted) {
        const server = this.getEventServer();
        server.events.responsePresentation(member_uuid, accepted);
    }

    // 사용자 강퇴
    kickParticipant(id) {
        const server = this.getEventServer();
        server.events.kickMemeber(id);
        // this.mateServer.events.kickMemeber(id);
    }
    // 사용자의 카메라 on/off 알림
    setMemberCamera(member_uuid, muted) {
        const server = this.getEventServer();
        server.events.setMemberCamera(member_uuid, muted);
    }
    // 사용자의 마이크 on/off 알림
    setMemberMic(member_uuid, muted) {
        const server = this.getEventServer();
        server.events.setMemberMic(member_uuid, muted);
    }
    
    /**
     * vod 
     */
    // vod 등록
    setVodList(file) {
        const server = this.getEventServer();
        server.events.setVodList(file);
    }
    // vod 삭제
    deleteVodItem(uuid) {
        const server = this.getEventServer();
        server.events.deleteVodItem(uuid);
    }
    // focus vod
    selectVodItem(uuid) {
        const server = this.getEventServer();
        server.events.selectVodItem(uuid);
    }

    /**
     * 설문 조사 
     */
    notifySurvey(uuid) {
        const server = this.getEventServer();
        server.events.notifySurvey(uuid);
    }
    replySurvey(uuid) {
        const server = this.getEventServer();
        server.events.replySurvey(uuid);
    }
    
    /**
     * CHAT (채팅)
     */
    sendTextMessage(message) {
        if (message.type === 'file' && !message.content.downloadLink) return;
        const server = this.getEventServer();
        server.events.sendTextMessage(message);
    }
    sendPrivateTextMessage(participants, message) {
        const server = this.getEventServer();
        server.events.sendPrivateTextMessage(participants, message );
    }

    // /**
    //  * 알림
    //  */
    sendNotification(message, group_id) {
        const server = this.getEventServer();
        // const content = {
        //     message, 
        //     group_id
        // };
        server.events.sendNotification(message, group_id);
    }

    /**
     * 그룹
     */
    setGroupRunnigStatus(running) {
        const server = this.getEventServer();

        server.events.setGroupRunnigStatus(running);
    }
    initJoin() {
        this.mateServer.events.join(true);
    }
}

export default new MateManagement();
